'use strict'

exports = module.exports
exports.multicodec = '/ipfs/id/1.0.0'
exports.listener = require('./listener')
exports.dialer = require('./dialer')



//////////////////
// WEBPACK FOOTER
// ./~/libp2p-identify/src/index.js
// module id = 618
// module chunks = 0